let registrationPromise: Promise<ServiceWorkerRegistration> | null = null;

/**
 * Register the application's service worker without requesting permission,
 * creating a push subscription, or changing an existing subscription.
 *
 * Keeping the promise at module scope lets app startup and the push manager
 * share one registration path.
 */
export function ensureServiceWorkerRegistration(): Promise<ServiceWorkerRegistration> {
  if (!("serviceWorker" in navigator)) {
    return Promise.reject(new Error("Service workers are not supported"));
  }

  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((error) => {
        registrationPromise = null;
        throw error;
      });
  }

  return registrationPromise;
}